import React from 'react';
import { Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import LoginPage from 'pages/Login';
import { ForgotPasswordPage, ResetPasswordPage, Success } from 'pages/Login/PasswordReset';
import SsoPage from 'pages/Sso';
import UserRoute from './UserRoute';
import App from './App';

const AppRoutes = ({ location }) => (
  <Switch>
    <Route
      exact
      path="/login"
      component={ LoginPage }
    />
    <Route
      exact
      path="/login/forgotPassword"
      component={ ForgotPasswordPage }
    />
    <Route
      exact
      path="/login/resetPassword"
      component={ ResetPasswordPage }
    />
    <Route
      exact
      path="/login/resetSuccess"
      component={ Success }
    />
    <Route
      exact
      path="/sso"
      component={ SsoPage }
    />
    <UserRoute
      redirectRoute="/login"
      route="/"
      component={ App }
      location={ location }
    />
  </Switch>
);

AppRoutes.propTypes = {
  location: PropTypes.object.isRequired
};

export default AppRoutes;
